import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { updateSystem } from '../index';
export const useUpdateSystem = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(updateSystem, {
        onSuccess: () => {
            // Форма редактирования читает систему из списка - его и инвалидируем.
            queryClient.invalidateQueries('GetAllSystems');
            setAction({
                type: 'success',
                message: 'Updating the system was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
